// src/utils.ts
function noop() {
}
export {
  noop
};
//# sourceMappingURL=utils.js.map